<template>
  <transition name="el-fade-in-linear" mode="out-in">
    <div v-if="modal" class="modal-backdrop">
      <div class="modal-pane">
        <component 
          v-loading="loading"
          element-loading-spinner="qc-spinner"
          :is="modal" 
          v-bind="mProps" 
          v-on="events" />
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'modal-container',
    data () {
      return {
        loading: false,
        modal: null,
        mProps: {},
        events: {}
      }
    },
    created () {
      this.$modal.setContainer(this)
    },
    methods: {
      show(modal, props, events) {
        this.modal = modal
        this.mProps = props
        this.events = events
      },
      setLoading(loading) {
        this.loading = loading
      },
      close() {
        this.events = {}
        this.mProps = {}
        this.modal = null
        this.loading = false
      }
    }
  };
</script>

<style>
  .modal-backdrop {
    position: fixed;
    z-index: 9998;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-pane {
    min-width: 60%;
    max-width: 90%;
  }
</style>